import { guardedApiRequest } from '@/calls/helpers';

const getUser = async (exhibitionId) => guardedApiRequest(`routes/get_user?exhibition_id=${exhibitionId}`, {
  method: 'GET',
});

const updateUser = async (data) => guardedApiRequest('routes/edit_account', {
  method: 'POST',
  body: data
});

export {
  // eslint-disable-next-line
  getUser,
  updateUser
};
